var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 2.22A1 1 0 0112 3v4.136c1.824.154 5.707.837 8.603 3.84 2.53 2.625 3.674 6.354 3.395 11.083a1 1 0 01-.997.94h-.057A1.002 1.002 0 0122 21.934v-.11c-.01-.495-.162-2.35-1.757-4.01C18.54 16.043 15.76 15.084 12 14.94v4.06a1 1 0 01-1.625.782l-10-8a1 1 0 010-1.561zM10 5.08L2.6 11l7.4 5.92v-3.011a1 1 0 011-1c4.63 0 8.119 1.08 10.378 3.215-.477-1.464-1.212-2.715-2.202-3.746-3.017-3.142-7.521-3.282-8.095-3.287h-.06l-.011-.002-.01.002c-.042 0-.077-.02-.117-.024-.091-.01-.181-.018-.263-.053-.057-.023-.1-.064-.151-.097-.054-.036-.114-.062-.16-.108a1 1 0 01-.173-.244c-.014-.025-.035-.043-.047-.07-.038-.085-.051-.182-.064-.278-.004-.037-.023-.068-.024-.105l.002-.007c0-.005-.003-.01-.003-.014V5.08z",
    fill: "#222",
    fillRule: "evenodd",
    className: "fi-icon-base-fill"
  })));
}

export default SvgIconReply;